import type { AlgoliaCompanyRecord } from '../../types/algolia-company-record';
import { partitionCountsAsIntegerPercentages } from './partition-counts-as-integer-percentages';

type PickRemoteness = Pick<
  AlgoliaCompanyRecord,
  'remotenessDistribution' | 'remotenessRemotePct' | 'remotenessHybridPct'
>;

/**
 * Single "remote + hybrid" share for UI copy. Prefer raw counts (correct partition); otherwise clamp stored pcts.
 */
export function getCombinedRemoteHybridPercentForDisplay(company: PickRemoteness): number | null {
  const dist = company.remotenessDistribution;
  if (dist) {
    const total = dist.remote + dist.hybrid + dist.onsite;
    if (total <= 0) return null;
    const p = partitionCountsAsIntegerPercentages({
      remote: dist.remote,
      hybrid: dist.hybrid,
      onsite: dist.onsite,
    });
    return Math.min(100, (p.remote ?? 0) + (p.hybrid ?? 0));
  }

  const r = company.remotenessRemotePct;
  const h = company.remotenessHybridPct;
  if (r != null && h != null) return Math.min(100, r + h);
  if (r != null) return Math.min(100, r);
  if (h != null) return Math.min(100, h);
  return null;
}
